// frontend/src/components/MembersFiltersSidebar.jsx

import React from 'react';
import { useTranslation } from '../i18n';
import CountrySelect from './fields/CountrySelect';

export default function MembersFiltersSidebar({
  open,
  onClose,
  values,
  onChange,
  onApply,
  onClear
}) {
  const { _, lang } = useTranslation()

  if (!open) return null;

  return (
    <aside
      className="fixed inset-y-0 left-0 w-60 max-w-full bg-white
                 text-[#111418] dark:bg-gray-900 dark:text-gray-100
                 shadow-lg p-4 z-50 overflow-y-auto border-r
                 border-[#f0f2f5] dark:border-gray-700"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold">
          Filtros
        </h2>
        <button
          type="button"
          onClick={onClose}
          className="button-secondary px-2 py-1"
        >
          {_('Close')}
        </button>
      </div>

      <form
        className="space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          onApply();
        }}
      >
        <div>
          <label className="block text-sm mb-1">
            {_('Nationality')}
          </label>
          <CountrySelect
            name="nationality"
            value={values.nationality || ''}
            onChange={(e) => onChange('nationality', e.target.value)}
            className="input-inline w-full"
          />
        </div>

        <div>
          <label className="block text-sm mb-1">
            {_('National ID')}
          </label>
          <input
            type="text"
            value={values.national_id || ''}
            onChange={(e) => onChange('national_id', e.target.value)}
            className="input-inline w-full"
          />
        </div>

        <div>
          <label className="block text-sm mb-1">
            {_('Passport')}
          </label>
          <input
            type="text"
            value={values.passport || ''}
            onChange={(e) => onChange('passport', e.target.value)}
            className="input-inline w-full"
          />
        </div>

        <div>
          <label className="block text-sm mb-1">
            {_('Full Name')}
          </label>
          <input
            type="text"
            value={values.first_name || ''}
            onChange={(e) => onChange('first_name', e.target.value)}
            className="input-inline w-full"
            placeholder={_('First / Middle Name')}
          />
        </div>

        <div>
          <label className="block text-sm mb-1">
            {_('Full Last Name')}
          </label>
          <input
            type="text"
            value={values.last_name || ''}
            onChange={(e) => onChange('last_name', e.target.value)}
            className="input-inline w-full"
            placeholder={_('Last Name(s)')}
          />
        </div>

        <div className="flex gap-2 pt-2">
          <button
            type="submit"
            className="button-primary"
          >
            {_('Apply')}
          </button>
          <button
            type="button"
            className="button-secondary px-2 py-1"
            onClick={onClear}
          >
            {_('Clear')}
          </button>
        </div>
      </form>
    </aside>
  );
}
